import { Flex, Image, Text } from "@chakra-ui/react";
import { type CdpVendor } from "lib/sanity/queries/compare-cdps";
import React from "react";
import { ArrowLink } from "ui/link";
import { LinkCard } from "ui/link-card";

type CdpVsCardProps = {
  slug: string;
  firstCdpVendor: CdpVendor;
  secondCdpVendor: CdpVendor;
};

export function CdpVsCard({ slug, firstCdpVendor, secondCdpVendor }: CdpVsCardProps) {
  return (
    <LinkCard
      as="li"
      href={`/compare-cdps/${slug}`}
      width="100%"
      p={{ base: 6, lg: 8 }}
      border="1px"
      borderRadius="base"
      borderColor="base.border"
      transition="all .15s ease-in-out"
      _hover={{
        borderColor: "gray.400",
        opacity: 1,
      }}
    >
      <Flex gap={{ base: 6, lg: 8 }} mb={{ base: 6, lg: 8 }} alignItems="center" fontSize="xl" fontWeight="semibold">
        <Image
          width="36px"
          height="36px"
          src={`${firstCdpVendor.logoUrl}?w=72`}
          alt={`${firstCdpVendor.name}.`}
          objectFit="contain"
        />

        <Text>vs</Text>

        <Image
          width="36px"
          height="36px"
          src={`${secondCdpVendor.logoUrl}?w=72`}
          alt={`${secondCdpVendor.name}.`}
          objectFit="contain"
        />
      </Flex>

      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Text fontWeight="semibold" maxW={{ lg: "150px" }}>
          {firstCdpVendor.name} vs {secondCdpVendor.name}
        </Text>

        <ArrowLink transition="opacity .15s ease-in-out" justifySelf="flex-end" size="md" />
      </Flex>
    </LinkCard>
  );
}
